import React from "react";
import { v4 as uuid_v4 } from "uuid";

import "./Card.css";

const Card = ({ item, click }) => {

  return (
    <React.Fragment>
      <div className="marketing-card-wrapper">
        {item.map((Val, index) => {
          return (
              <div
                className="modal-content"
                key={uuid_v4()}
                id={Val.id}
                onClick={() => click(Val.id)}
              >
                <img src={Val.img} alt={Val.title} />
                <h2 className="modal-content-title">{Val.title}</h2>
                <div className="modal-content-tags">
                  {Val.tags.map((tag) => (
                    <p className="modal-content-tag" key={uuid_v4()}>
                      {tag}
                    </p>
                  ))}
                </div>
              </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

export default Card;
